import React from "react";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APILA } from "../../../../../config/apila";
import { faBookOpenReader } from '@fortawesome/free-solid-svg-icons';
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ClipLoader, PulseLoader} from "react-spinners";
import ModalRapor from './modal/rapor';
import { APIMS } from "../../../../../config/apims";

/* ===========================
   🔥 SKELETON SHIMMER STYLE
=========================== */
const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(
      to right,
      #ddeaffff 8%,
      #f4f8ffff 18%,
      #ddeaffff 33%
    );
    background-size: 800px 104px;
  }
  .shimmer-select {
    height: 35px;
    border-radius: 4px;
  }
  .shimmer-row {
    height: 38px;
  }

  // .at-search{ min-width: 280px; }
  // .at-input{
  //   width:100%;
  //   height: 38px;
  //   border:1px solid #280095;
  //   border-radius: 10px;
  //   padding: 0 12px;
  //   font-size: 13px;
  //   outline:none;
  // }
  // .at-input:focus, .at-select:focus{
  //   border-color:#94a3b8;
  //   box-shadow: 0 0 0 3px rgba(148,163,184,0.25);
  // }
    
  `;



export default function Dimensi() {
  document.title = "Rapor";

  const [savingId, setSavingId] = useState(null);

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  const [loading, setLoading] = useState(false);
  const firstLoadDone = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");
  const storageSchoolId = localStorage.getItem('ysb_school_id');
  const storageTeacher = localStorage.getItem('teacherID');
  const storageBranch = localStorage.getItem('ysb_branch_id');
  
  // Data master
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);

  // Table data
  const [getData, setGetData] = useState([]);
  const [getDataKop, setGetDataKop] = useState([]);

  // Search (frontend)
  const [searchKeyword, setSearchKeyword] = useState("");

  // UI state
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_teacher_id: "",
  });

  // EDIT nilai
  const [form3, setForm3] = useState({
    ysb_element_recap_id_id: "",
    ysb_sub_element_value: "",
  });

  const [updateId, setUpdateID] = useState(null);
  const id_user = localStorage.getItem("id_admin") || "";
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");

  // Permission
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];
    if (level === "developer" || level === "superadmin") {
      setPermission({ create: 1, read: 1, update: 1, delete: 1 });
      return;
    }
    const foundPermission = storageItems.find((item) => item.menu?.url === location.pathname);
    if (!foundPermission) navigate("/dashboard");
    else {
      setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
      });
    }
  }, [location.pathname, navigate]);

  /* API HEADERS */
  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  // ---------- helper refs ----------
  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);

  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  // =========================
  // INIT: Semester + Dimensi
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [semesterRes, dimensiRes] = await Promise.all([
        // APILA.get(
        //   `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
        //   { ...fetchParams, signal: controller.signal }
        // ),
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
        APILA.get(
          `/api/access/dimensis?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
      ]);

      if (!isMounted.current) return;

      // Semester aktif
      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find((s) => s.status === 1) || semesters[0];
        setGetDataSemesterMap(semesters);
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
        }
      }

      // Dimensi aktif pertama
      if (dimensiRes?.status === 200) {
        const dims = (dimensiRes.data.data || []).filter((d) => d.status === 1);
        setGetDataDimensi(dims);
        if (dims.length > 0) setForm2((prev) => ({ ...prev, ysb_dimensi_id: dims[0].id }));
      }
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || err.message || "Error",
        icon: "error",
      });
    } finally {
        setLoading(false);       // ⬅️ shimmer BARU MATI DI SINI
    }
  }, [ascending, descending, fetchParams, keyword, limit, page, storageBranchGroping, storageLevel]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);


  // =========================
  // Filter complete
  // =========================
  const isFilterComplete =
    isFilterDirty && !!form2.ysb_semester_id;

  // =========================
  // Fetch table data
  // =========================
  const GetResponseData = useCallback(async () => {
  if (
    !form2.ysb_semester_id ||
    !form2.ysb_dimensi_id
  ) return;

  const params = {

     ysb_semester_id: form2?.ysb_semester_id,
          level: storageLevel,
          branch: storageBranch,
        //   ysb_dimensi_id: form2?.ysb_dimensi_id,
          ysb_school_id: storageSchoolId,
          ysb_teacher_id: storageTeacher
  };

  try {
    const response = await APILA.get(
      "/api/element-recaps-rapot-teacher/rapot",
      {
        params,
        ...fetchParams,
      }
    );

    if (response?.status === 200) {
      setGetData(response.data.data || []);
      setGetDataKop(response.data.data_kop || []);
    }
  } catch (error) {
    swal({
      title: "Gagal",
      text: error?.response?.data?.message || "Gagal mengambil data",
      icon: "error",
    });
  }
}, [form2, fetchParams, storageLevel]);


  // AUTO SELECT TAB
  useEffect(() => {
    if (getData.length > 0 && getData[0]?.data_element?.length > 0 && !selectedTab) {
      setSelectedTab(getData[0].data_element[0].name_element);
    }
  }, [getData, selectedTab]);

  // FIRST LOAD: tampilkan table otomatis setelah default filter lengkap
  useEffect(() => {
    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id ||
      !form2.ysb_dimensi_id
    ) return;
  
    firstLoadDone.current = true;
  
    (async () => {
      setIsFetching(true);
      await GetResponseData(); // ✅ HANYA SEKALI
      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);
      setIsFetching(false);
    })();
  
  }, [
    form2.ysb_semester_id,
    form2.ysb_dimensi_id
  ]);

  // Reset tab kalau filter berubah
  useEffect(() => {
    setSelectedTab(null);
  }, [
    form2.ysb_semester_id,
    form2.ysb_dimensi_id
  ]);

  // =========================
  // HANDLER perubahan filter (select HTML)
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm2((prev) => ({ ...prev, [name]: value }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };


  // =========================
  // BUTTON CARI
  // =========================
  const handleCari = async () => {
    // validasi (biar user jelas)
    if (!form2.ysb_semester_id) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan Semester sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setSelectedTab(null);
    setGetData([]);
    setSearchKeyword("");
    setHasSearched(false);
    setIsFetching(true);

    try {
      await GetResponseData();
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };


  // const [showModal, setShowModal] = useState(false);
  // const [selectedRapor, setSelectedRapor] = useState(null);
  // const [dataKopRapor, setdataKopRapor] = useState(null);
  

  // const viewModalRapor = (id, rapor) => {
  //   try {
  //     setSelectedRapor(rapor || null);
  //     setShowModal(true);
  //     setdataKopRapor(getDataKop);
  //   } catch (err) {
  //     console.error('viewModalRapor error', err);
  //   }
  // }

    const [showModal, setShowModal] = useState(false);
    const [selectedRapor, setSelectedRapor] = useState(null);
    const [dataKopRapor, setdataKopRapor] = useState(null);
  
    const viewModalRapor = (id, rapor) => {
      try {
        // tutup dulu sebentar agar modal tidak membawa state murid sebelumnya
        setShowModal(false);
  
        setTimeout(() => {
          setSelectedRapor(rapor || null);
          setdataKopRapor(getDataKop || null);
          setShowModal(true);
        }, 0);
      } catch (err) {
        console.error("viewModalRapor error", err);
      }
    };
  
    const handleCloseModalRapor = () => {
      setShowModal(false);
      setSelectedRapor(null);
      setdataKopRapor(null);
    };

  // =========================
  // SEARCH FILTER (frontend)
  // =========================
  // const filteredData = useMemo(() => {
  //   const q = (searchKeyword || "").trim().toLowerCase();
  //   if (!q) return getData;

  //   return (getData || []).filter((item) => {
  //     const name = (item?.name_student || "").toString().toLowerCase();
  //     const nisn = (item?.nisn || "").toString().toLowerCase();
  //     return name.includes(q) || nisn.includes(q);
  //   });
  // }, [getData, searchKeyword]);
  // =========================
// SEARCH + SORT (frontend)
// - search: nama / NISN
// - sort : nama siswa A -> Z
// =========================
  const filteredData = useMemo(() => {
    const q = (searchKeyword || "").trim().toLowerCase();

    const base = q
      ? (getData || []).filter((item) => {
          const name = (item?.name_student || "").toString().toLowerCase();
          const nisn = (item?.nisn || "").toString().toLowerCase();
          return name.includes(q) || nisn.includes(q);
        })
      : (getData || []);

    // ✅ Urutkan nama siswa A -> Z (case-insensitive)
    return [...base].sort((a, b) => {
      const an = (a?.name_student || "").toString().trim();
      const bn = (b?.name_student || "").toString().trim();

      const cmpName = an.localeCompare(bn, "id", { sensitivity: "base" });
      if (cmpName !== 0) return cmpName;

      // Tie-breaker biar stabil (kalau nama sama)
      const aNisn = (a?.nisn || "").toString();
      const bNisn = (b?.nisn || "").toString();
      return aNisn.localeCompare(bNisn, "id", { numeric: true, sensitivity: "base" });
    });
  }, [getData, searchKeyword]);

  const toTitleCase = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";
    return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
  };


   return (
    <>
      <style>{shimmerStyle}</style>

      <div className="body" >
        {/* <div className="body-header d-flex">
          {isTabletOrMobile ? 
            <>
              <div className="title-page">
                <h6><FontAwesomeIcon icon={faListUl}/> Rapor</h6>
              </div> 
            </>
            : 
            <>
              <div className="title-page">
                <h5><FontAwesomeIcon icon={faListUl}/> Rapor </h5>
              </div>
            </>
          }   
        </div>  */}

      <div className="page-header-card">
         {isTabletOrMobile ? (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faBookOpenReader} />
                  </span>
                <h4 className="page-title-text"> Rapor</h4>
              </div>
            </div>

             <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-teacher">Beranda</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                  Rapor
                </li>
              </ol>
            </nav>
          </>
          ) : (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faBookOpenReader} />
                </span>
                <h4 className="page-title-text"> Rapor</h4>
              </div>
            </div>

            <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-teacher">Beranda</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                  Rapor
                </li>
              </ol>
            </nav>
          </>
         )}
      </div>

        {/* <div className="body-content-menu">
          <div className="breadcrumb-header " style={{fontSize:"13px" }}>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"> <Link style={{textDecoration:"none"}} to="/dashboards-la-main">Beranda</Link>  </li>
                <li className="breadcrumb-item iniaktif" > <span className='ml-2'> Rapor </span> </li>
              </ol>
            </nav>
          </div>
        </div> */}
                    
        <div className="body-content">
        
          {/* FILTER */}
          {isTabletOrMobile ? (
            <div className="title-page">
              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                <select
                  className="mr-2"
                  name="ysb_semester_id"
                  value={form2.ysb_semester_id}
                  onChange={handleChange}
                  style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}
                >
                  <option value="" hidden>
                    {namaTA} (Semester {namaSmstr})
                  </option>
                  {getDataSemesterMap.map((user, index) => (
                    <option key={index} value={user?.id}>
                      {user?.name_year} (Semester {user?.semester})
                    </option>
                  ))}
                </select>
              </Row>
              <Row style={{ marginTop: "12px", padding: "0 12px" }}>
                <button
                  onClick={handleCari}
                  disabled={!isFilterComplete}
                  className="btn"
                  style={{
                    fontSize: "13px",
                    padding: "10px 16px",
                    borderRadius: "12px",
                    backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                    color: "#fff",
                    cursor: !isFilterComplete ? "not-allowed" : "pointer",
                  }}
                >
                  Cari
                </button>
              </Row>
            </div>
          ) : (
            <>
              <div className="mb-3">
                {loading ? (
                  <>
                    <div className="mb-3 d-flex">
                      <div className="shimmer shimmer-select mr-2" style={{width:180, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:70, borderRadius: "12px"}} />
                    </div>
                  </>
                ) : (
                    <div className="mb-3 mt-1">
                      <div className="d-flex">
                        <select
                          className="mr-2"
                          name="ysb_semester_id"
                          value={form2.ysb_semester_id}
                          onChange={handleChange}
                          style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              background: "#fff",
                            }}
                        >
                          <option value="" hidden>
                            {namaTA} (Semester {namaSmstr})
                          </option>
                          {getDataSemesterMap.map((user, index) => (
                            <option key={index} value={user?.id}>
                              {user?.name_year} (Semester {user?.semester})
                            </option>
                          ))}
                        </select>
                        <button
                          onClick={handleCari}
                          disabled={!isFilterComplete}
                          className="btn"
                          style={{
                            fontSize: "13px",
                            padding: "10px 16px",
                            borderRadius: "12px",
                            backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                            color: "#fff",
                            cursor: !isFilterComplete ? "not-allowed" : "pointer",
                          }}
                        >
                          Cari
                        </button>

                      </div>
                    </div>
                )
              }
              </div>
              
            </>           
          )}

         {/* LOADER di area table (opsional tapi bagus) */}
            {isFetching && (
              <div className="text-center" style={{ padding: "10px 0" }}>
                <span style={{color: "#2e52aeff", fontWeight: "500"}}><PulseLoader color={'#3f5bea'} size={12}/></span>
              </div>
          )}

         



          {/* TABLE hanya muncul jika sudah search (atau first load selesai) */}
          {hasSearched && !isFetching && (
            <>
             <div className="mt-3">
            <div className="at-search">
              <input
                                className="at-input"
                                placeholder="Cari Siswa / NISN"
                                value={searchKeyword}
                                onChange={(e) => setSearchKeyword(e.target.value)}
              />
            </div>
          </div>

          <Col xl='12' sm='12'> 
                          <div className="mt-3">
                            <div className="body-table" >
                              <div>
                                <table className="table  w-100 table-hover table-bordered" id="basic-datatable">
                                  <thead >
                                    <tr >
                                      <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}} className="text-center">No</th>
                                      <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}} className="text-center">Nama Siswa</th>
                                      <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}} className="text-center">Nisn</th>
                                      <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}} className="text-center">Aksi</th>
                                    </tr>
                                  </thead>
                                  <tbody>

                                    {filteredData.length === 0 ? (
                                      <tr>
                                        <td colSpan={4} className="text-center" style={{ padding: "12px" }}>
                                          Data tidak ditemukan
                                        </td>
                                      </tr>
                                    ) : (
                                      <>
                                        {filteredData.map((rapor, index) => (
                                      <tr key={index}>
                                        <td className='text-center' style={{ lineHeight: "2" }}> {(page - 1) * 10 + (index + 1)} </td>
                                        {/* <td style={{ lineHeight: "2" }}> {rapor.name_student} </td> */}
                                        <td style={{ lineHeight: "2" }}>{toTitleCase(rapor.name_student)}</td>
                                        <td style={{ lineHeight: "2", textAlign: "center" }}> {rapor.nisn} </td>
                                        <td className='text-center'>
                                          <button   className="button-edit button-table text-center" onClick={() => viewModalRapor(rapor?.ysb_student_id || rapor?.id, rapor)}>
                                            Lihat Rapor
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                      </>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </Col>
            </>
            

                        
          )}

          {/* {selectedRapor && (
                      <ModalRapor
                        show={showModal}
                        onHide={() => setShowModal(false)}
                        data_rapor={selectedRapor}
                        data_kop={dataKopRapor}
                        id_student={selectedRapor?.ysb_student_id || selectedRapor?.id}
                        getData={getData}
                      />
                    )} */}
          {selectedRapor && (
            <ModalRapor
              key={selectedRapor?.ysb_student_id || selectedRapor?.id}
              show={showModal}
              onHide={handleCloseModalRapor}
              data_rapor={selectedRapor}
              data_kop={dataKopRapor}
              id_student={selectedRapor?.ysb_student_id || selectedRapor?.id}
              getData={getData}
            />
          )}

        </div>
      </div>
    </>
  );
}
